// extracted by mini-css-extract-plugin
export default {"dashboardGrid":"AdminMainPage_dashboardGrid__c+LT4","topRow":"AdminMainPage_topRow__3bDcC","bottomRow":"AdminMainPage_bottomRow__UieEZ","title":"AdminMainPage_title__T8gaT"};